import PageHeading from "../components/page-heading";
import { FaPhoneVolume } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { EMAIL, PHONE } from "../constants";
import { Link } from "react-router-dom";

export default function ContactPage() {
    const contact = [
        {
            icon: <FaLocationDot className="main-color text-5xl" />,
            title: "Location",
            description: (
                <p className="gray-color text-sm">
                    Plot 213 Acheng Kathy Odongo Street
                    <br />
                    Ober Village, Zuma parish, Myene Sub-County, Oyam District
                </p>
            ),
        },
        {
            icon: <FaPhoneVolume className="main-color text-5xl" />,
            title: "Call us",
            description: (
                <div>
                    <Link className="gray-color text-sm" to={"tel:" + PHONE}>
                        {PHONE}
                    </Link>
                    <p className="gray-color text-sm">{EMAIL}</p>
                </div>
            ),
        },
        {
            icon: <MdEmail className="main-color text-5xl" />,
            title: "Email",
            description: (
                <Link className="gray-color text-sm" to={"mailto:" + EMAIL}>
                    {EMAIL}
                </Link>
            ),
        },
    ];
    return (
        <div>
            <PageHeading title="Contact Us" />
            <div className="grid lg:grid-cols-2 container py-20 gap-10">
                <div className="flex flex-col px-4 divide-y divide-dashed divide-gray-500">
                    {contact.map((c, i) => (
                        <div key={i} className="py-8 flex gap-6">
                            {c.icon}
                            <div>
                                <h6 className="font-semibold mb-3">{c.title}</h6>
                                {c.description}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="px-8 lg:px-4">
                    <h4 className="text-3xl font-semibold">Leave Us a Message</h4>
                    <p className="gray-color my-4">
                        If you have any questions please fell free to contact with us.
                    </p>

                    <div className="contact-form">
                        <input type="text" placeholder="Your name" />
                        <input type="text" placeholder="Your Phone Number" />
                        <input type="text" placeholder="Your Email" />
                        <textarea placeholder="Your Message" rows={5}></textarea>
                        <button className="main-btn px-8 py-3 capitalize">
                            send message
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
